if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyImage = this.querySelector('.js-inventory-urgency-image');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock.replace('-', '');
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock.replace('-', '');
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          // this.inventoryNotice.innerText = theme.strings.inStock; 
          this.inventoryNotice.innerHTML = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 16.21C12.4183 16.21 16 12.6283 16 8.20999C16 3.79166 12.4183 0.209991 8 0.209991C3.58167 0.209991 0 3.79166 0 8.20999C0 12.6283 3.58167 16.21 8 16.21Z" fill="#008500"/>
            <path d="M10.2106 5.59598C10.2912 5.49233 10.3915 5.40557 10.5056 5.34066C10.6198 5.27575 10.7456 5.23396 10.8759 5.21768C11.0062 5.20139 11.1385 5.21094 11.2651 5.24577C11.3917 5.28059 11.5103 5.34002 11.6139 5.42065C11.7176 5.50128 11.8043 5.60154 11.8692 5.7157C11.9341 5.82986 11.9759 5.95569 11.9922 6.086C12.0085 6.21631 11.999 6.34856 11.9641 6.47518C11.9293 6.6018 11.8699 6.72033 11.7892 6.82398L8.29924 11.3113C8.21507 11.4232 8.10832 11.5161 7.98591 11.584C7.85524 11.6568 7.70988 11.6993 7.56058 11.7083C7.41659 11.7172 7.27239 11.6948 7.1379 11.6426C7.00341 11.5904 6.88184 11.5097 6.78158 11.406L4.12658 8.74998C4.03107 8.65774 3.95488 8.54739 3.90248 8.42539C3.85007 8.30338 3.82248 8.17216 3.82133 8.03938C3.82017 7.9066 3.84547 7.77492 3.89576 7.65203C3.94604 7.52913 4.02029 7.41748 4.11418 7.32359C4.20808 7.22969 4.31973 7.15544 4.44262 7.10516C4.56552 7.05488 4.6972 7.02958 4.82998 7.03073C4.96276 7.03189 5.09398 7.05947 5.21598 7.11188C5.33799 7.16429 5.44833 7.24047 5.54058 7.33598L7.40624 9.20165L10.2109 5.59565L10.2106 5.59598Z" fill="white"/>
          </svg>`;         
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          let messageText = '';
          let imageUrl = '';

          if (inventoryLevel === 'very_low') {
          messageText = this.dataset.textVeryLow.replace('-', '');
          imageUrl = this.dataset.imageVeryLow;
          } else if (inventoryLevel === 'low') {
          messageText = this.dataset.textLow.replace('-', '');
          imageUrl = this.dataset.imageLow;
          } else if (inventoryLevel === 'backordered') {
          messageText = this.dataset.textNoStockBackordered.replace('-', '');
          imageUrl = this.dataset.imageNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          messageText = this.dataset.textNormal.replace('-', '');
          imageUrl = this.dataset.imageNormal;
          } else if (inventoryLevel === 'none') {
          messageText = this.dataset.textNoStock.replace('-', '');
          imageUrl = this.dataset.imageNoStock;
          }

          this.urgencyMessage.innerHTML = messageText;

          if (this.urgencyImage) {
            if (imageUrl) {
              this.urgencyImage.src = imageUrl;
              this.urgencyImage.hidden = false;
            } else {
              this.urgencyImage.hidden = true;
            }
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
